import type { KeenSliderInstance } from "keen-slider";
import { useCallback } from "react";

export const useSyncSlideClasses = () => {
  const syncSlideClasses = useCallback((slider: KeenSliderInstance | null) => {
    const slides = slider?.slides;
    const details = slider?.track?.details;

    slides?.forEach((slide, index) => {
      const slideDetail = details?.slides[index];
      const isActive = index === details?.rel;
      const isVisible = (slideDetail?.portion ?? 0) > 0;

      slide.classList.toggle("carousel-slide-active", isActive);
      slide.classList.toggle("carousel-slide-visible", isVisible);
    });
  }, []);

  return { syncSlideClasses };
};
